import { useEffect, useRef, useState } from 'react';

const useAutoAdvance = (
  isComplete: boolean,
  onComplete: () => void,
  delayMs: number,
  resetKey?: string,
) => {
  const previousResetKey = useRef(resetKey);
  const previousComplete = useRef(isComplete);
  const [isAutoAdvancing, setIsAutoAdvancing] = useState(false);

  useEffect(() => {
    if (previousResetKey.current !== resetKey) {
      previousResetKey.current = resetKey;
      previousComplete.current = isComplete;
      setIsAutoAdvancing(false);
      return undefined;
    }

    if (isComplete && !previousComplete.current) {
      previousComplete.current = true;
      setIsAutoAdvancing(true);
      const timeout = setTimeout(onComplete, delayMs);
      return () => {
        clearTimeout(timeout);
        setIsAutoAdvancing(false);
      };
    }

    if (!isComplete) {
      previousComplete.current = false;
      setIsAutoAdvancing(false);
    }

    return undefined;
  }, [isComplete, onComplete, delayMs, resetKey]);

  return { isAutoAdvancing };
};

export default useAutoAdvance;
